// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

/*
  UMD header generated via modularize.js at 2015-04-02T22:08:30.008Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:vendor/jquery_ui/jquery-ui-1.10.3.custom': [],
  'minted:html': [],
  'minted:model/info_dialog': [],
  'templito:util': []
})(this, function (m_module, Backbone, $, _) {

var M = m_module.M;

M.View = M.View || {};

/**
 * @class M.View.InfoDialog
 *
 * InfoDialog View
 *
 * An M.View.InfoDialog is passed an instance of M.Model.InfoDialog which
 * defines what needs to be rendered in the dialog. This includes things like * the body and the title.
 *
 */
M.View.InfoDialog = Backbone.View.extend({
  tagName: 'div',

  /**
   * Params specified in options - not all inclusive yet
   * @param {Boolean} closeOnEscape, optional - whether or not to close
   *   dialog on 'esc' key press
   * @param {Boolean} hideCloseButton, optional - specify whether or not to
   *   hide the close button (the X at the top right corner)
   */
   initialize: function() {
    //backbone 1.0 already provides $el.  remove when everything using
    //this is upgraded
    this.$el = this.$el || $(this.el);
    if (this.options.events) {
      this.events = this.options.events;
      this.delegateEvents();
    }
  },

  render: function() {
    var self = this;
    this.$el.html(this.model.get('body'));
    this.defaults = {
      autoOpen: true,
      modal: this.options.model || false,
      resizable: false,
      draggable: false,
      width: this.options.width || 400,
      height: this.options.height || 'auto',
      minHeight: 0,
      title: this.model.get('title'),
      //zIndex doesn't work with jquery ui 1.10.
      //the proper way to handle this is to attach
      //the dialog at a point which will stack naturally
      //usually near the bottom.
      zIndex: 3000,
      //there is a style that sets the index using this class...
      dialogClass: this.options.dialogClass || "infoDialog",
      closeOnEscape: this.options.closeOnEscape,
      open: function(event, ui) {
        if (self.options.hideCloseButton) {
          $(".ui-dialog-titlebar-close", ui.dialog).hide();
        }
      },
      close: function() {
        self.close();
      }
    };
    if (self.options.appendTo) {
      this.defaults['appendTo'] = self.options.appendTo;
    }
    this.$el.dialog(
      $.extend({}, this.defaults, this.options.settings)
    );

    return this;
  },

  /**
   * Close the dialog and trigger a close event
   */
  close: function() {
    this.trigger('close');
    this.remove();
  }

}, { // Static functions

  /**
   * Creates an instance of a View.InfoDialog for a basic dialog
   * that closes the dialog on click.
   * @param title
   * @param bodyText
   * @param buttonTextDict {Dict} A dictionary that contains the
   *   primaryButtonText and secondaryButtonText button text
   * @param additionalViewOpts
   * @returns {M.View.InfoDialog}
   */
  createWithPrimaryAndOptSecondaryButton: function(title, bodyText, buttonTextDict,
      additionalViewOpts, previewImage, createWithButtons) {

    // By default, we assume we're always going to have a primary button
    var primaryButtonText = "ok";
    var secondaryButtonText = null;
    if (buttonTextDict) {
      primaryButtonText = buttonTextDict.primaryButtonText || primaryButtonText;
      secondaryButtonText =  buttonTextDict.secondaryButtonText || secondaryButtonText;
    }

    // Setup the template and the model
    createWithButtons = createWithButtons === undefined ? true : createWithButtons;
    var templateBody = M.Template.Util.InfoDialog({
      bodyText: bodyText,
      primaryButtonText: primaryButtonText,
      secondaryButtonText: secondaryButtonText,
      previewImage: previewImage || null,
      createWithButtons: createWithButtons
    });

    var dialogModel = new M.Model.InfoDialog({
      title: title,
      body: templateBody
    });

    // Setup and create the view
    var viewOptions = {
      model: dialogModel,
      dialogClass: "flat-white-ui infoDialog",
      width: "auto",
      // By default, append the dialogs to the "main" div, which should be on
      // all python pages. If the "main" div doesn't exist, it will append it
      // to the bottom of the page as usual. This can be overridden in
      // additionalViewOpts for non-python pages or pages missing the "main" div
      appendTo: ".main"
    };
    _.extend(viewOptions, additionalViewOpts);

    // event handlers
    var events = {
      'click .buttonPrimary': 'close'
    };

    if (additionalViewOpts &&
        typeof(additionalViewOpts['events']) !== 'undefined') {
      events = _.extend(events, additionalViewOpts['events'])
    }

    viewOptions['events'] = events;

    return new M.View.InfoDialog(viewOptions);
  }

});

return {
  'InfoDialog': M.View.InfoDialog
};

});
